<template>
  <div class="item-box-content">
    <el-row>
      <el-col :span="12" style="font-size:12px;color:#acaeb0;">{{"* 已作废发货清单将退回待发货清单，可重新发起发货"}}</el-col>
      <el-col :span="12" style="text-align:right;">
        <el-button @click="onInitiateShipment" type="primary" :disabled="deliverState" plain>发起发货</el-button>
      </el-col>
    </el-row>
    <el-table
      style="margin-top:10px"
      ref="custromTableRef"
      :data="warehousing"
      max-height="378"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      border
    >
      <el-table-column label="发货编号">
        <template slot-scope="scope">
          <span class="approval" @click="onShipmentDetails(scope.row)">{{scope.row.deliverNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="instockNumber" label="入库单编号">
        <template slot-scope="scope">
          <span>{{scope.row.instockNumber||'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="logisticType" label="配送类型"></el-table-column>
      <el-table-column show-overflow-tooltip prop="shipment" label="发货信息"></el-table-column>
      <el-table-column show-overflow-tooltip prop="shipmentTime" label="发货时间">
        <template slot-scope="scope">
          <span>{{scope.row.shipmentTime|dateFilter}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="deliverState" label="发货状态">
        <template slot-scope="scope">
          <span>{{dataList[scope.row.deliverState-1]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="inDate" label="入库时间">
        <template slot-scope="scope">
          <span>{{scope.row.inDate|dateFilter}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
export default {
  props: ['warehousing', 'deliverState', 'sendType'],
  data () {
    return {
      dataList: ['物流在途', '验收', '已入库', '已作废'],
      loadingTable: false
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 发起发货
    onInitiateShipment () {
      this.$router.push({
        name: 'initiateShipment',
        query: {
          type: this.$route.query.type,
          pcbId: this.$route.query.pcbId,
          sendType: this.sendType
        }
      })
    },
    // 发货详情
    onShipmentDetails (row) {
      this.$router.push({
        name: 'shipmentDetails',
        query: {
          type: this.$route.query.type,
          pcbId: this.$route.query.pcbId,
          deliverNumber: row.deliverNumber
        }
      })
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
</style>
